//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const items = ['foo', 'bar', 'fizz', 'buzz']
    const values = ref(['foo', 'bar'])

    return { items, values }
  },
}
